import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotificationMiddlewareService } from '../../shared/services/notifications/notifications-middleware.service';
import { WebAppSharedModule } from '../../shared/shared.module';
import { WebAppSettingsComponent } from './settings.component';
import { WebAppSettingsService } from './settings.service';

const routes: Routes =
	[
		{
			path: '',
			component: WebAppSettingsComponent,
			data: { title: 'Modules.Settings.PageTitle' },
		},
	];

@NgModule({
	declarations: [WebAppSettingsComponent],
	imports:
		[
			CommonModule,
			WebAppSharedModule,
			RouterModule.forChild(routes)
		],
	providers: [WebAppSettingsService, NotificationMiddlewareService]
})
export class WebAppSettingsModule { }